import { useInfiniteQuery } from '@tanstack/react-query';

import { queryFn, getQueryKey } from './queryFn';

import type { AdditionalScreenerFilter } from '../types';

type GenNextPageParamCreatorParams = {
  limit: number;
  initPage: number;
  totalHits?: number | null;
  allCurrentPagesLength: number;
};

export const calcNextPage = ({
  limit,
  initPage,
  totalHits,
  allCurrentPagesLength,
}: GenNextPageParamCreatorParams) => {
  const totalPages = totalHits ? Math.ceil(totalHits / limit) : 0;
  const nextPage = initPage + allCurrentPagesLength;
  return nextPage < totalPages ? nextPage : null;
};

type HookParams = {
  gridViewId: number;
  limit: number;
  initPage?: number;
  enabled?: boolean;
  displayRecentlyAddedCompanies?: boolean;
  returnRecentCompaniesOnly?: boolean;
  additionalFilters: AdditionalScreenerFilter[];
};

export const useInfinitePredefinedScreenersQuery = ({
  gridViewId,
  displayRecentlyAddedCompanies = true,
  returnRecentCompaniesOnly = false,
  limit,
  initPage = 0,
  enabled = true,
  additionalFilters,
}: HookParams) => {
  return useInfiniteQuery({
    enabled,
    queryFn,
    queryKey: getQueryKey({
      gridViewId,
      limit,
      initPage,
      displayRecentlyAddedCompanies,
      returnRecentCompaniesOnly,
      additionalFilters,
    }),
    staleTime: 60000 * 60, // 1 hour
    initialPageParam: initPage,
    retry: 1,
    getNextPageParam: (lastPage, allPages) => {
      const totalHits = lastPage.totalHits;
      const newCompaniesTotalHits = lastPage.newCompaniesTotalHits;
      const allCurrentPagesLength = allPages.length;
      return calcNextPage({
        limit,
        initPage,
        totalHits: returnRecentCompaniesOnly
          ? newCompaniesTotalHits
          : totalHits,
        allCurrentPagesLength,
      });
    },
  });
};
